module.exports = function() {
  return new Worker(__webpack_public_path__ + "90c4a8753d8c2f7dd02b.worker.js");
};